export function sortSelectionsByName(locale, s1, s2) {
    return s1.name.localeCompare(s2.name, locale, { numeric: true });
}
//# sourceMappingURL=sortSelectionsByName.js.map